<script lang="ts">
	import czechIcon from "@assets/images/cz.svg?raw";
	import englishIcon from "@assets/images/en.svg?raw";
	import Icon from "@components/common/Icon.svelte";
	import Link from "@components/common/Link.svelte";
	import { isMenuActive } from "@utils/isMenuActive.js";
	import { Locale } from "@core/schema/Locale.js";
	import type { MenuItem } from "@core/schema/MenuItem.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	const { menu }: { menu: MenuItem[] } = $props();
	const { tenant, pagePath } = getGlobalTemplateProps();

	const linkClasses =
		"underline decoration-transparent hover:decoration-black underline-offset-4 transition-all py-4 px-4";

	const localeIconMap: Record<Locale, string> = {
		[Locale.cs]: czechIcon,
		[Locale.en]: englishIcon,
	};
</script>

<header class={["grid-container sticky z-50 mt-4 md:mb-16 top-4"]}>
	<div class="gap-4 bg-white hidden lg:flex rounded-full px-12 shadow-sm left-0 right-0 mx-auto w-fit">
		{#each menu as menuItem, index (index)}
			<Link
				class={[
					linkClasses,
					{
						"font-bold": isMenuActive(menuItem, pagePath[tenant.locale] ?? "/"),
					},
				]}
				href={menuItem.href}
				target={menuItem.target}
			>
				{menuItem.name}
			</Link>
		{/each}

		{#each Object.values(Locale).filter((locale) => locale !== tenant.locale) as locale (locale)}
			<Link class={linkClasses} href={pagePath[locale]}>
				<Icon class="w-6 h-6" icon={localeIconMap[locale]} />
			</Link>
		{/each}
	</div>
</header>
